module.exports = __webpack_public_path__ + "img/remove.26fe45de.svg";